import {Bounce, Power1, Power2, Power3, Back, gsap} from 'gsap';
import {StageLayer} from '@nolimitcity/slot-launcher/bin/StageLayer';
import {SlotGame} from '@nolimitcity/slot-game/bin/SlotGame';
import {IDimOrientation, LayoutDimData, ResizeHelper} from '../../../core/utils/ResizeHelper';
import {BitmapTextStyleOptions, TextStyleOptions} from '../../../core/setting/text/IText';
import {BitmapCountUp} from '../../../core/component/BitmapCountUp';
import {Translator} from '../../../core/setting/Translator';
import {TranslationTexts} from '../../config/translate/TranslationTexts';
import {Helper} from '../../../core/utils/Helper';
import {MathHelper} from '../../../core/utils/MathHelper';
import {AnimationEffects} from '../../../core/effects/AnimationEffects';
import {GameAssets} from '../../GameAssets';
import { BLEND_MODES } from 'pixi.js';
import { Beheaded } from '../../Beheaded';
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { GraveSnatchers } from '../../Font/GraveSnatchers';
import { Sequence } from '../../../core/displayobject/Sequence';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class CountDisplay extends PIXI.Container implements StageLayer {
    protected readonly counterDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 270),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 270),
        },
    };

    
    private readonly _style_low: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 40,
        letterSpacing: 12,
    };

    private readonly _style_Medium: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 46,
        letterSpacing: 12,
    };

    private readonly _styleWays: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 7.5,
        fill: 'white',
        fontFamily: 'Helvetica',
        fontSize: 32,
        fontStyle: 'italic',
        fontWeight: 'bold',
        miterLimit: 0,
        strokeThickness: 3,
    };

    private readonly multTestText = {
        fontFamily: GraveSnatchers.FAMILY,
        fontSize: 96,
        stroke: '#000000',
        strokeThickness: 10,
        fill: '#ce1313',
        dropShadow: true,
        dropShadowColor: '#000000',
        dropShadowAlpha: 0.7,
        dropShadowAngle: 0.6,
        dropShadowDistance: 8,
        padding: 20,
        lineJoin: 'round',
    }

    private downDistance: number = 260;

    private spBGHelper:PIXI.Sprite;

    protected _countUp: BitmapCountUp;
    protected _countUpFX: BitmapCountUp;

    protected _multBitMap: PIXI.Text;
    protected _multBitMapFX: PIXI.Text;

    protected _waysTxt: PIXI.Text;
    protected _timeline: gsap.core.Timeline;
    protected _bounceTl: gsap.core.Timeline;
    protected _movementTL: gsap.core.Timeline;
    protected _waysTL: gsap.core.Timeline;

    protected spineCont: PIXI.Container;
    protected spinePart: SpinePlayer[];

    protected _multVTL: gsap.core.Timeline;

    protected smoke:Sequence;

    public get dim(): LayoutDimData {
        return ResizeHelper.calcDim(this.counterDim);
    }

    public get timeRemaining(): number {
        return this._timeline && this._timeline.isActive() ? this._timeline.duration() - this._timeline.totalTime() : 0;
    }

    private get bothCounters():BitmapCountUp[]{
        return [this._countUp,this._countUpFX]
    }

    private set waysText(value: number) {
        this._waysTxt.text =
            value.toString() + ' ' + Translator.translate(value == 1 ? TranslationTexts.WAY_WON : TranslationTexts.WAYS_WON);
        this._waysTxt.updateTransform();
    }

    constructor() {
        super();
        this.init();
    }

    protected init(): void {

        // this.spinePart = [];

        // this.spineCont = this.addChild(new PIXI.Container());
        // for(let i = 0; i < 20; i++){
        //     this.spineCont.addChild(new SpinePlayer("spine/soul.json"));
        //     // this.spinePart.push(spine);
        // }

        this.smoke = this.addChild(new Sequence({texturePath:"smoke_puff_2"}));
        this.smoke.blendMode = BLEND_MODES.ADD;
        this.smoke.anchor.set(0.5,0.6);
        this.smoke.visible = false;
        this.smoke.scale.set(6,4);
        this.smoke.tint = 0xff0000;

        this.spBGHelper = this.addChild(new PIXI.Sprite(Beheaded.assetLoader.getTextures("fontBase")[0]));
        this.spBGHelper.alpha = 0;
        this.spBGHelper.anchor.set(.5,.42);
      
        this._countUp = this.addChild(new BitmapCountUp(this._style_low));
        this._countUp.alpha = 0;
        (this._countUp.anchor as PIXI.Point).set(0.5);


        this._countUpFX = this.addChild(new BitmapCountUp(this._style_low));
        this._countUpFX.alpha = 0;
        (this._countUpFX.anchor as PIXI.Point).set(0.5,1);


        this._multBitMap = this.addChild(new PIXI.Text("",this.multTestText));
        this._multBitMap.alpha = 0;
        (this._multBitMap.anchor as PIXI.Point).set(0.5,0.5);
        this._multBitMap.text = "X1";
        this._multBitMap.y = -0;
        this._multBitMap.tint = 0xff0000;

        this._multBitMapFX = this.addChild(new PIXI.Text("",this.multTestText));
        this._multBitMapFX.alpha = 0;
        (this._multBitMapFX.anchor as PIXI.Point).set(0.5,0.75);
        this._multBitMapFX.text = "X1";
        this._multBitMapFX.y = -0;
        this._multBitMapFX.tint = 0xff0000;

        this._waysTxt = this.addChild(new PIXI.Text(''));
        this._waysTxt.alpha = 0;
        this._waysTxt.style = this._styleWays;
        this._waysTxt.anchor.set(0.5);

        this.countUpAnimVal(0);
        this.onResize();
    }

    public changeToBigWinFont(val:boolean){
        if(val){
            this._countUp.fontSize = this._style_Medium.fontSize;
            this._countUpFX.fontSize = this._style_Medium.fontSize;
        }else{
            this._countUp.fontSize = this._style_low.fontSize;
            this._countUpFX.fontSize = this._style_low.fontSize;
        }
    }

    public playBigWin(from: number, to: number, duration: number, ways: number = 1): gsap.core.Timeline {
        this._timeline = Helper.setTimeline(
            this._timeline!,
            new gsap.core.Timeline({onComplete: () => this.countUpAnimVal(to)})
        );

        const deciNumber: number = MathHelper.floorToDecimals(to, 2);
        this.waysText = ways;

        this._timeline.add(
            this._countUp.getCountUpAnimation(from, deciNumber, {duration: duration, ease: Power2.easeInOut}),
            0
        );
        this._timeline.to(this._countUp.scale, {x: 1, y: 1, duration: duration, ease: 'Power3.easeIn'}, 0);
        
        this._timeline.add(
            AnimationEffects.Shake({
                x: 1.5,
                y: 1.5,
                obj: this._countUp,
                hertz: 80,
                duration: 1,
                updateOnComplete: true,
                positionCb: () => new PIXI.Point(0),
                Intensity: 2.75,
                ease: Power2.easeOut,
            }),duration-1
        );
       

        return this._timeline;
    }

    public play(from: number, to: number, duration: number, ways: number = 1): gsap.core.Timeline {
        this._timeline = Helper.setTimeline(
            this._timeline,
            new gsap.core.Timeline({onComplete: () => this.countUpAnimVal(to)})
        );
  
        this.spBGHelper.position = this._countUp.position;
        this._countUp.scale.set(1);
        this._timeline.fromTo(this.spBGHelper,{alpha:0},{alpha:0.6, duration:duration *0.2},0)

        const deciNumber: number = MathHelper.floorToDecimals(to, 2);
        this._timeline.add(this._countUp.getCountUpAnimation(from, deciNumber, {duration: duration, ease: Power1.easeOut}),0);

        if (from == 0) {
            this._timeline.fromTo(this._countUp, {alpha: 0}, {duration: duration * 0.8, alpha: 1}, 0);
        } else{
            this._countUp.alpha = 1;
        } 
      
        this.waysText = ways;

        return this._timeline;
    }

    public displayMult(val: number,timesDurr:number = 1.5) {
        this._multVTL = Helper.setTimeline(this._multVTL);
        this._multBitMapFX.text = this._multBitMap.text = "X"+val;
        timesDurr += val > 6 ? 1 : 0;
        this._multBitMapFX.children.forEach(sp => {
            (sp as PIXI.Sprite).blendMode = BLEND_MODES.ADD;
        });
        const toScale:number = 1+ val*0.1;
        this._multVTL.add(() => {
            Beheaded.soundPlayer.playSound(SoundConfig.MULTI_UP);
        })

        this.spBGHelper.position = this._multBitMap.position;
        this._multVTL.fromTo(this._multBitMap.scale,{x:0.6,y:0.6},{duration:0.25 * timesDurr,x:toScale,y:toScale,ease:"Back.easeOut"},0);
        this._multVTL.fromTo(this._multBitMap,{alpha:0},{duration:0.1 * timesDurr , alpha:1},0);
        this._multVTL.to(this._multBitMap,{duration:0.2 * timesDurr, alpha:0},0.5);

        this._multVTL.fromTo(this.spBGHelper,{alpha:0},{alpha:0.8,duration:this._multVTL.duration()/2},0)
        this._multVTL.to(this.spBGHelper,{alpha:0,duration:this._multVTL.duration()/2},this._multVTL.duration()/2)

        return this._multVTL;
    }

    private countUpAnimVal(val: number): void {
        this._countUp.showValue(val);
        this._countUpFX.showValue(val);
    }

    public showWays(duration: number = 0.65): void {
        this._waysTL = Helper.setTimeline(this._waysTL, new gsap.core.Timeline(), true);
        const scaledHeight = this._countUp.height / Math.min(this._countUp.scale.y, 1);

        this._waysTL.fromTo(this._waysTxt, {alpha: 0, y:scaledHeight/1.25}, {y:scaledHeight, alpha: 1, duration: duration, ease:'back.easeOut'}, 0);
    }

    public bounceHit(intencity: number = 0, durr: number = 0.2, resetScale?:boolean,bigWinScale?:boolean): gsap.core.Timeline {
        this._bounceTl = Helper.setTimeline(this._bounceTl, new gsap.core.Timeline());
        if (!intencity) return this._bounceTl;

        intencity = intencity;
        const initScale: number = resetScale ? 1 : bigWinScale ? 0.78 : this._countUp.scale.x;
        const inc: number = this._countUp.scale.x + intencity * 0.05;

        this._bounceTl.to(this._countUp.scale, {duration: durr / 2, x: inc, y: inc}, 0);
        this._bounceTl.to(this._countUp.scale, durr, {x: initScale, y: initScale, ease: 'bounce.easeOut'}, durr / 2);

        return this._bounceTl;
    }

    private tlShake:gsap.core.Timeline
    public ShakeItBaby(intencity: number = 2, durr: number = 0.2): gsap.core.Timeline {
        this.tlShake = Helper.setTimeline(this.tlShake,gsap.timeline({onComplete:() => {
        }}));
        this.tlShake.to(this._countUp.scale, {x: 0.78, y: 0.78, duration: durr, ease: 'power3.easeIn'}, 0);
        this.tlShake = AnimationEffects.Shake({
            x: 1.01,
            y: 1.01,
            obj: this._countUp,
            hertz: 60,
            duration: durr,
            updateOnComplete: true,
            positionCb: () => new PIXI.Point(0, 0),
            Intensity: intencity,
            ease: Power3.easeOut,
        });
        return this.tlShake;
    }

    public moveDown(scaling: boolean = true, duration: number = 0.5): gsap.core.Timeline {
        this._movementTL = Helper.setTimeline(this._movementTL, new gsap.core.Timeline({onComplete:() => {
            this.spBGHelper.alpha = 0.5;
        }}));

        if (scaling) this._movementTL.to(this.scale, {x: '-=' + 0.27, y: '-=' + 0.27, duration: duration});
        return this._movementTL.to(this.position, {
            y: '+=' + this.downDistance,
            duration: duration,
            ease: "back.in(2)"
        });
    }

    public moveToReset(durr: number,withEase:boolean =true ): gsap.core.Timeline {
        this._movementTL = Helper.setTimeline(this._movementTL, new gsap.core.Timeline());
        this._movementTL.to(this.spBGHelper,{alpha:0},0)
        this._movementTL.to(this.scale, {x: this.dim.scale.x, y: this.dim.scale.y, duration: durr}, 0);
        return this._movementTL.to(
            this.position,
            durr,
            {y: this.dim.position.y, x: this.dim.position.x, duration: durr, ease: withEase  ? 'power3.easeOut' : undefined },
            0
        );
    }

    public stop(
        endValue?: number,
        duration: number = 0.5,
        delay: number = 1,
        useLastAlpha: boolean = false
    ): gsap.core.Timeline {
        this._timeline = Helper.setTimeline(this._timeline!, new gsap.core.Timeline());
        this._waysTL = Helper.setTimeline(this._waysTL,undefined,true);

        if (this._countUp.alpha == 0) return this._timeline;
        if (endValue) this._countUp.showValue(endValue);

        let startAlpha: number = useLastAlpha ? this._countUp.alpha : 1;
        let startAlphaWays: number = useLastAlpha ? this._waysTxt.alpha : 1;

        this._timeline.to(this.spBGHelper,{delay: delay, alpha:0, duration:duration},0)
        this._timeline.fromTo(this._countUp, {alpha: startAlpha}, {delay: delay, duration: duration, alpha: 0}, 0);
        this._timeline.fromTo(this._waysTxt, {alpha: startAlphaWays}, {
            delay: delay,
            duration: duration,
            alpha: 0
        }, 0);
        this._timeline.play(0.001);
        return this._timeline;
    }

    public playTotalWin(value: number, duration?: number) {
        this._countUp.text = SlotGame.apiPlugin.currency.formatValue(value);
        this._countUp.scale.set(1, 1);
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.fromTo(this._countUp,  {alpha: 0}, {alpha: 1,duration:duration});
        tl.play();
        return tl;
    }

    public applyValue(value: number): void {
        this._countUp.text = SlotGame.apiPlugin.currency.formatValue(value);
        this._countUp.scale.set(1, 1);
    }

    public onResize(): void {
        this.position = this.dim.position;
        this.scale = this.dim.scale;
    }
}